import { useEffect, useState } from 'react'
import { useAppSelector } from 'src/hooks'
import { addErrorSDKToast } from 'src/utils/helpers'
import { selectMeetingParticipants } from 'src/app/meeting'
import { selectSessionId } from 'src/app/session'

const sendAppInvite = (participantUUIDs: string[]) => {
  try {
    window.zoomSdk.sendAppInvitation({
      participantUUIDs,
    })
  } catch (e) {
    addErrorSDKToast(e)
  }
}

// invite all the participants if we have "showBadges" toggled on
// and if there is an active session
// any participants who join the meeting later will be added via "useOnParticipantChange"
export const useSendAppInvitation = (
  showBadges: boolean,
  isGettingParticipants: boolean
) => {
  const [sentOut, setSentOut] = useState(false)
  const participants = useAppSelector(selectMeetingParticipants)
  const participantUUIDs = Object.values(participants).map(
    ({ participantUUID }) => participantUUID
  )
  const activeSessionId = useAppSelector(selectSessionId)

  useEffect(() => {
    if (activeSessionId) setSentOut(false)
  }, [activeSessionId])

  useEffect(() => {
    if (
      showBadges &&
      !sentOut &&
      !isGettingParticipants &&
      activeSessionId &&
      // don't send if we don't have any participants
      participantUUIDs.length
    ) {
      setSentOut(true)
      sendAppInvite(participantUUIDs)
    }
  }, [
    showBadges,
    sentOut,
    participantUUIDs,
    isGettingParticipants,
    activeSessionId,
  ])
}
